export const ASSET_CATEGORIES = {
  IT_OFFICE: {
    id: 'IT_OFFICE',
    label: 'IT & Office',
    color: '#185FA5',
    bg: '#E6F1FB',
    subtypes: [
      'Computer / Laptop',
      'Server / NAS',
      'Netzwerk-Equipment',
      'Drucker / Scanner',
      'Monitor / Display',
      'Telefon / Headset',
      'Büromöbel / Ausstattung',
      'Sonstiges IT',
    ],
  },
  MACHINES: {
    id: 'MACHINES',
    label: 'Maschinen',
    color: '#3B6D11',
    bg: '#EAF3DE',
    subtypes: [
      'CNC-Maschine',
      'Presse / Stanze',
      'Fräse / Drehmaschine',
      'Schweißgerät',
      'Kompressor / Druckluft',
      'Förderanlage / Band',
      'Hydraulikanlage',
      'Sonstige Maschine',
    ],
  },
  CONSTRUCTION: {
    id: 'CONSTRUCTION',
    label: 'Baugeräte',
    color: '#854F0B',
    bg: '#FAEEDA',
    subtypes: [
      'Bagger / Radlader',
      'Kran / Hebebühne',
      'Rüttler / Verdichter',
      'Betonmischer / Pumpe',
      'Gerüst / Schalungssystem',
      'Handwerkzeug (elektrisch)',
      'Vermessungsgerät',
      'Sonstiges Baugerät',
    ],
  },
  MEDICAL: {
    id: 'MEDICAL',
    label: 'Medizin- & Einsatztechnik',
    color: '#993556',
    bg: '#FBEAF0',
    subtypes: [
      'Diagnose / Bildgebung',
      'Beatmungsgerät',
      'Defibrillator / AED',
      'Infusionspumpe',
      'Patientenmonitor',
      'Rettungsfahrzeug-Equipment',
      'Schutzausrüstung (PSA)',
      'Sonstige Medizintechnik',
    ],
  },
  BUILDING: {
    id: 'BUILDING',
    label: 'Gebäudetechnik & Infrastruktur',
    color: '#534AB7',
    bg: '#EEEDFE',
    subtypes: [
      'Heizung / HVAC / Klima',
      'Aufzug / Hebebühne',
      'Brandschutz / Alarmanlage',
      'Zutrittssystem / Schließanlage',
      'Elektroverteiler / MSR',
      'USV / Notstromanlage',
      'Beleuchtung / Notbeleuchtung',
      'Sonstige Gebäudetechnik',
    ],
  },
  VEHICLES: {
    id: 'VEHICLES',
    label: 'Fahrzeuge & Transport',
    color: '#3C3489',
    bg: '#EEF0FE',
    subtypes: [
      'PKW / Dienstfahrzeug',
      'Transporter / LKW',
      'Gabelstapler / Ameise',
      'Anhänger / Auflieger',
      'Elektrisches Fahrzeug / E-Bike',
      'Wasserfahrzeug',
      'Sonstiges Fahrzeug',
    ],
  },
  MEASURING: {
    id: 'MEASURING',
    label: 'Mess- & Prüftechnik',
    color: '#0F6E56',
    bg: '#E1F5EE',
    subtypes: [
      'Multimeter / Oszilloskop',
      'Druckmessgerät',
      'Temperaturmessgerät',
      'Durchflussmessgerät',
      'Kalibriergerät',
      'Prüfstand',
      'Sonstige Messtechnik',
    ],
  },
};

export const ASSET_STATES = {
  ACTIVE: {
    id: 'ACTIVE',
    label: 'In Betrieb',
    color: '#1b8a45',
    bg: '#d7f5e3',
    dot: '#2eb85c',
  }, // success
  MAINTENANCE: {
    id: 'MAINTENANCE',
    label: 'In Wartung',
    color: '#b3790d',
    bg: '#fef2da',
    dot: '#f9b115',
  }, // warning
  DEFECTIVE: {
    id: 'DEFECTIVE',
    label: 'Defekt',
    color: '#c23636',
    bg: '#fbe2e2',
    dot: '#e55353',
  }, // danger
  STORAGE: {
    id: 'STORAGE',
    label: 'Lager',
    color: '#5d6573',
    bg: '#ebedef',
    dot: '#9da5b1',
  }, // secondary
  RESERVED: {
    id: 'RESERVED',
    label: 'Reserviert',
    color: '#1f7fd1',
    bg: '#dceeff',
    dot: '#3399ff',
  }, // info
  DECOMMISSIONED: {
    id: 'DECOMMISSIONED',
    label: 'Ausgemustert',
    color: '#212333',
    bg: '#d8d9dd',
    dot: '#4f5d73',
  }, // dark
};

export const MAINTENANCE_TYPES = [
  'Inspektion',
  'Wartung',
  'Reparatur',
  'Prüfung / Zertifizierung',
  'Schadensmeldung',
  'Einlagerung / Auslagerung',
  'Kalibrierung',
  'Sonstiges',
];

export const INITIAL_LOCATIONS = [
  {
    id: 'L01',
    name: 'Wien – Hauptgebäude',
    address: 'Mariahilfer Str. 10, 1060 Wien',
    active: true,
  },
  {
    id: 'L02',
    name: 'Linz – Werk Süd',
    address: 'Industriezeile 45, 4020 Linz',
    active: true,
  },
  {
    id: 'L03',
    name: 'Graz – Außenstelle',
    address: 'Grazbachgasse 7, 8010 Graz',
    active: true,
  },
  {
    id: 'L04',
    name: 'Lager Nord',
    address: 'Lagerhausstraße 3, 4055 Pucking',
    active: true,
  },
  {
    id: 'L05',
    name: 'Salzburg – Depot',
    address: 'Aignerstraße 12, 5020 Salzburg',
    active: true,
  },
];

export const INITIAL_ASSETS = [
  {
    id: 'A001',
    name: 'HP EliteBook 840 G10',
    category: 'IT_OFFICE',
    subtype: 'Computer / Laptop',
    serialNumber: 'HP2024-001-XY',
    inventoryNumber: 'INV-2024-0041',
    locationId: 'L01',
    state: 'ACTIVE',
    assignedTo: 'Max Müller',
    purchaseDate: '2024-02-15',
    warrantyUntil: '2027-02-15',
    value: 1490,
    lastMaintenance: '2025-01-10',
    nextMaintenance: '2026-01-10',
    notes: 'SSD-Erweiterung auf 1TB nachgerüstet.',
    maintenanceHistory: [
      {
        id: 'MH001',
        date: '2025-01-10',
        type: 'Inspektion',
        technician: 'IT Support',
        notes: 'Reinigung, OS Update, BIOS aktualisiert',
      },
      {
        id: 'MH002',
        date: '2024-08-22',
        type: 'Reparatur',
        technician: 'IT Support',
        notes: 'Tastatur defekt – getauscht',
      },
    ],
    createdAt: '2024-02-15T10:00:00.000Z',
    updatedAt: '2025-01-10T14:00:00.000Z',
    syncStatus: 'synced',
  },
  {
    id: 'A002',
    name: 'CNC-Fräse DMG Mori DMU 50',
    category: 'MACHINES',
    subtype: 'Fräse / Drehmaschine',
    serialNumber: 'DMG-50-2022-338',
    inventoryNumber: 'INV-2022-0012',
    locationId: 'L02',
    state: 'MAINTENANCE',
    assignedTo: 'Werkstatt Linz',
    purchaseDate: '2022-05-01',
    warrantyUntil: '2025-05-01',
    value: 85000,
    lastMaintenance: '2025-04-01',
    nextMaintenance: '2025-06-01',
    notes: 'Quartalswartung planmäßig KW22.',
    maintenanceHistory: [
      {
        id: 'MH003',
        date: '2025-04-01',
        type: 'Wartung',
        technician: 'DMG Mori Service',
        notes: 'Ölwechsel, Spindel geprüft, Kühlkreislauf gespült',
      },
      {
        id: 'MH004',
        date: '2025-01-10',
        type: 'Inspektion',
        technician: 'DMG Mori Service',
        notes: 'Kalibrierung X/Y/Z-Achse, Geometrieprüfung',
      },
    ],
    createdAt: '2022-05-01T08:00:00.000Z',
    updatedAt: '2025-04-01T09:30:00.000Z',
    syncStatus: 'synced',
  },
  {
    id: 'A003',
    name: 'Defibrillator Physio-Control LIFEPAK 15',
    category: 'MEDICAL',
    subtype: 'Defibrillator / AED',
    serialNumber: 'PC-LP15-2023-007',
    inventoryNumber: 'INV-2023-0099',
    locationId: 'L01',
    state: 'ACTIVE',
    assignedTo: 'Ersthelfer Team',
    purchaseDate: '2023-03-18',
    warrantyUntil: '2026-03-18',
    value: 12500,
    lastMaintenance: '2025-03-18',
    nextMaintenance: '2025-09-18',
    notes: 'Halbjährliche Prüfpflicht gem. MPBetreibV §11.',
    maintenanceHistory: [
      {
        id: 'MH005',
        date: '2025-03-18',
        type: 'Prüfung / Zertifizierung',
        technician: 'Medizintechnik GmbH',
        notes: 'DGUV V3 – bestanden. Prüfprotokoll Nr. 2025-03-018.',
      },
    ],
    createdAt: '2023-03-18T11:00:00.000Z',
    updatedAt: '2025-03-18T16:00:00.000Z',
    syncStatus: 'synced',
  },
  {
    id: 'A004',
    name: 'Caterpillar 320 Hydraulikbagger',
    category: 'CONSTRUCTION',
    subtype: 'Bagger / Radlader',
    serialNumber: 'CAT320-2021-4421',
    inventoryNumber: 'INV-2021-0005',
    locationId: 'L04',
    state: 'STORAGE',
    assignedTo: '',
    purchaseDate: '2021-09-10',
    warrantyUntil: '2024-09-10',
    value: 210000,
    lastMaintenance: '2024-11-20',
    nextMaintenance: '2025-05-20',
    notes: 'Winterlager. Einsatz ab KW20 geplant.',
    maintenanceHistory: [
      {
        id: 'MH006',
        date: '2024-11-20',
        type: 'Einlagerung / Auslagerung',
        technician: 'Eigenpersonal',
        notes: 'Hydrauliköl geprüft, Batterie abgeklemmt',
      },
    ],
    createdAt: '2021-09-10T07:00:00.000Z',
    updatedAt: '2024-11-20T15:00:00.000Z',
    syncStatus: 'synced',
  },
  {
    id: 'A005',
    name: 'Siemens LOGO! Brandmeldezentrale',
    category: 'BUILDING',
    subtype: 'Brandschutz / Alarmanlage',
    serialNumber: 'SIE-BZ-2020-17',
    inventoryNumber: 'INV-2020-0003',
    locationId: 'L01',
    state: 'ACTIVE',
    assignedTo: 'Haustechnik',
    purchaseDate: '2020-01-15',
    warrantyUntil: '2023-01-15',
    value: 4200,
    lastMaintenance: '2025-01-15',
    nextMaintenance: '2026-01-15',
    notes: 'Jährliche Prüfpflicht durch zugelassenen Fachbetrieb (TRVB 123).',
    maintenanceHistory: [
      {
        id: 'MH007',
        date: '2025-01-15',
        type: 'Prüfung / Zertifizierung',
        technician: 'Brandschutz GmbH',
        notes: 'Alle Melder geprüft. Protokoll abgelegt.',
      },
      {
        id: 'MH008',
        date: '2024-01-12',
        type: 'Wartung',
        technician: 'Brandschutz GmbH',
        notes: 'Batterien getauscht, Sensoren gereinigt',
      },
    ],
    createdAt: '2020-01-15T08:00:00.000Z',
    updatedAt: '2025-01-15T11:00:00.000Z',
    syncStatus: 'synced',
  },
  {
    id: 'A006',
    name: 'VW Crafter TDI 4x4',
    category: 'VEHICLES',
    subtype: 'PKW / Dienstfahrzeug',
    serialNumber: 'VW-CR-2023-BJ889',
    inventoryNumber: 'INV-2023-0021',
    locationId: 'L03',
    state: 'DEFECTIVE',
    assignedTo: 'Außendienst Graz',
    purchaseDate: '2023-06-01',
    warrantyUntil: '2026-06-01',
    value: 48000,
    lastMaintenance: '2024-12-01',
    nextMaintenance: '2025-06-01',
    notes: 'Motorschaden – Reparatur in Partnerwerkstatt.',
    maintenanceHistory: [
      {
        id: 'MH009',
        date: '2025-04-12',
        type: 'Schadensmeldung',
        technician: 'KFZ Werkstatt Graz',
        notes: 'Ölverlust am Motor. Fahrzeug steht.',
      },
      {
        id: 'MH010',
        date: '2024-12-01',
        type: 'Wartung',
        technician: 'VW Service Graz',
        notes: 'Jahresservice: Ölwechsel, Filter, Bremsbeläge vorne',
      },
    ],
    createdAt: '2023-06-01T10:00:00.000Z',
    updatedAt: '2025-04-12T08:00:00.000Z',
    syncStatus: 'synced',
  },
  {
    id: 'A007',
    name: 'Fluke 87V Digitalmultimeter',
    category: 'MEASURING',
    subtype: 'Multimeter / Oszilloskop',
    serialNumber: 'FL87V-2023-0044',
    inventoryNumber: 'INV-2023-0055',
    locationId: 'L02',
    state: 'ACTIVE',
    assignedTo: 'Elektro-Team Linz',
    purchaseDate: '2023-08-01',
    warrantyUntil: '2026-08-01',
    value: 480,
    lastMaintenance: '2024-08-01',
    nextMaintenance: '2025-08-01',
    notes: 'Jährliche Kalibrierungspflicht. DAkkS-Zertifikat erforderlich.',
    maintenanceHistory: [
      {
        id: 'MH011',
        date: '2024-08-01',
        type: 'Kalibrierung',
        technician: 'Kalibrierlabor Wien',
        notes: 'DAkkS-Kalibrierung. Zertifikat Nr. DAkkS-2024-0781.',
      },
    ],
    createdAt: '2023-08-01T09:00:00.000Z',
    updatedAt: '2024-08-01T12:00:00.000Z',
    syncStatus: 'synced',
  },
];
